// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuillFilterContainer-base__k66uC{display:flex;flex-wrap:wrap;gap:var(--size-3);align-items:flex-end;margin-bottom:var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "QuillFilterContainer-base__k66uC"
};
export default ___CSS_LOADER_EXPORT___;
